import React from "react";
import Navigation from "../../components/Mmpnavigation";
import Mmmproductscards from "../../components/Mmpproductcards";

export default function Mmp() {
  return (
    <div>
      <Navigation />
      <Mmmproductscards />
    </div>
  );
  // Search
  // Hero Banner
  // Product Cards Component
  // Productg CARD Component
  // Alternate product card
  // Product menu selection
  // Footer
}

/*
Improve Nav bar esthetics 
Improve onclick menu esthetics
Make hamburger menuy fx(changing to x and back to original form on blick)
On click submenu

Create search bar below navbar
Connect Navbar to context API

Temporarely remove Profile Account Icon
Footer
*/
